import { ShieldCheck, FileCheck2, HeartOff, Eye } from "lucide-react";
import { Reveal } from "@/components/landing/Reveal";

const ITEMS = [
  { icon: ShieldCheck, label: "80G Certified — donations are tax-deductible in India" },
  { icon: FileCheck2, label: "12A & FCRA Registered" },
  { icon: HeartOff, label: "Zero Euthanasia — no-kill since 2010" },
  { icon: Eye, label: "Transparent — every case publicly tracked" },
];

export function TrustStrip() {
  return (
    <section className="bg-white py-10 border-y border-amtm-border" data-testid="landing-trust-strip">
      <div className="max-w-6xl mx-auto px-6 md:px-10">
        <Reveal>
          <div className="flex flex-wrap justify-center gap-x-10 gap-y-4">
            {ITEMS.map(({ icon: Icon, label }) => (
              <div key={label} className="flex items-center gap-2 text-amtm-textMuted">
                <Icon className="h-4 w-4 shrink-0 stroke-[1.5]" />
                <span className="text-xs md:text-sm">{label}</span>
              </div>
            ))}
          </div>
        </Reveal>
      </div>
    </section>
  );
}
